import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProjectsV1Service {
  private apiUrl = environment.api.url;

  constructor(private afs: AngularFirestore, private http: HttpClient) {}

  /**
   * Updates a project in Firestore. Returns an Observable for compatibility.
   */
  updateProject(projectId: string, data: Partial<any>): Observable<void> {
    return from(
      this.afs.collection('investments').doc(projectId).set(data, { merge: true })
    );
  }

  /**
   * Gets a project by ID.
   */
  getProject(projectId: string): Observable<any> {
    return this.afs.collection('investments').doc(projectId).valueChanges();
  }

  /**
   * Creates (or rotates) the MangoPay wallet of a project.
   * Requires an authenticated admin session — the AuthInterceptor attaches
   * the Firebase Bearer token automatically for any /projects/ request.
   */
  async createProjectWallet(projectId: string): Promise<any> {
    return firstValueFrom(
      this.http.patch(`${this.apiUrl}/projects/${projectId}`, { projectId }),
    );
  }
}
